import React, { useState } from "react";
import Modal from "react-modal";
import * as yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MyForm from "./MyForm";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function FormModal(props) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  function openModal() {
    setModalIsOpen(true);
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  return (
    <div className="modal-general-container">
      <FontAwesomeIcon
        style={{ color: "black" }}
        className="modalheader"
        onClick={openModal}
        icon={faFileExport}
      />{" "}
      <Modal
        className="modal-genel-container"
        id={props.isNightMode ? "dark" : "light"}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}>
        <h2 id={props.isNightMode ? "dark" : "light"}>Contact Me!</h2>
        <MyForm />
        <ToastContainer />
      </Modal>
    </div>
  );
}

export default FormModal;
